import qs from 'qs';
import crypto from 'crypto-js/sha256';
import { DateUtil } from '@axiom/ui';

import { EnvUtil } from './env-util';

let pendoInitialized = false;

export const WindowUtil = {
  getRelayString(relayState) {
    return relayState
      ? encodeURIComponent(relayState)
      : encodeURIComponent(
          window.location.host +
            window.location.pathname +
            window.location.search +
            window.location.hash
        );
  },
  getLoginLink(relayState) {
    const relay = WindowUtil.getRelayString(relayState);
    return `${EnvUtil.loginUrl}?RelayState=${relay}`;
  },
  toLogin() {
    window.location.href = WindowUtil.getLoginLink();
  },
  exists() {
    /**
     * try/catch because next.js will throw error if trying to access window on the server >.<
     */
    try {
      return !!window;
    } catch {
      return false;
    }
  },
  getUrlQuery() {
    return qs.parse(window.location.search.slice(1));
  },
  initializePendo({ user = {}, candidate = {} }) {
    if (WindowUtil.exists() && window.pendo && !pendoInitialized) {
      pendoInitialized = true;
      /**
       * Pendo doesnt init every reload without the delay
       */
      const role = user?.roles?.[0] || null;
      const userId = user.id;

      const {
        homeOffice,
        profileStatus,
        availabilityPreferencesUpdatedAt,
        businessTitle,
        employmentStatus,
        employeeType,
        isSpotlightedLawyer,
        barredLocations,
        isProfileShared,
        id: candidateId,
        weeklyAvailability,
        soonestEngagementEndDate,
        isAccessibleToWorkFeed,
        primaryPracticeArea,
      } = candidate;

      setTimeout(() => {
        const isLPUser = role === 'LPUser';
        let daysSinceLastAvailabiltyUpdate = null;

        if (isLPUser) {
          const now = DateUtil.castAsMoment(new Date());
          const then =
            availabilityPreferencesUpdatedAt &&
            DateUtil.castAsMoment(availabilityPreferencesUpdatedAt);
          daysSinceLastAvailabiltyUpdate = then ? now.diff(then, 'days') : 0;
        }

        let barredAdmissions = 'Not Admitted';
        if (barredLocations?.length) {
          const bl = barredLocations.filter(
            b => b.name.toLowerCase() !== 'not admitted'
          );

          if (bl.length > 0) barredAdmissions = 'Admitted';
        }

        const payload = {
          visitor: {
            id: userId ? crypto(userId).toString() : null,
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            apUserId: user?.id,
            businessTitle,
            candidateStatus: isLPUser ? profileStatus : null,
            role,
            daysSinceLastAvailabiltyUpdate,
            acceptedTOS: !!user.termsAndConditionsAcceptedAt,
            homeOfficeName: homeOffice?.name || null,
            homeOfficeRegion: homeOffice?.categories || null,
            employmentStatus,
            employeeType,
            isSpotlighted: isSpotlightedLawyer ? 'ALT opt in' : 'ALT opt out',
            barredAdmissions,
            practiceArea: primaryPracticeArea,
            isProfileShared: isProfileShared
              ? 'Open to Client previews'
              : 'Not open to Client previews',
            isAccessibleToWorkFeed,
          },
          account: {
            id: 'AxiomLaw',
          },
        };
        // eslint-disable-next-line no-console
        console.log('Initing Pendo As:', payload.visitor);
        window.pendo.initialize(payload);
        WindowUtil.pendoTrack('initial_visit', {
          candidateId,
          profileStatus,
          weeklyAvailability,
          soonestEngagementEndDate,
          isAccessibleToWorkFeed,
        });
      }, 1000);
    }
  },
  pendoTrack(name, data) {
    if (
      WindowUtil.exists() &&
      window.pendo &&
      window.pendo.isReady &&
      window.pendo.isReady()
    ) {
      return window.pendo.track(name, data);
    }

    setTimeout(function () {
      WindowUtil.pendoTrack(name, data);
    }, 500);

    return null;
  },
  scrollToTop(elm) {
    if (this.exists()) {
      const options = {
        top: elm?.offsetTop || elm?.offsetParent?.offsetTop || 0,
        left: 0,
        behavior: 'smooth',
      };
      window.scrollTo(options);
    }
  },
};
